import { useMutation } from "react-query";

import { appEntryService } from "services";
import { ErrorResponse } from "types";

type UseSubmitApplicationMutationProps = {
	applicationId: string;
	onSuccess?: Function;
	onError?: Function;
};

const useSubmitApplicationMutation = ({
	applicationId,
	onSuccess,
	onError,
}: UseSubmitApplicationMutationProps) => {
	return useMutation(
		(appData: { [key: string]: any }) => {
			return appEntryService.submitApp({
				...appData,
				applicationId,
			});
		},
		{
			onSuccess(result) {
				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				onError?.(error);
			},
		},
	);
};

export default useSubmitApplicationMutation;
